import { render } from "./DailyReportExternalPreview.vue?vue&type=template&id=22c2ec7b"
import script from "./DailyReportExternalPreview.vue?vue&type=script&lang=ts"
export * from "./DailyReportExternalPreview.vue?vue&type=script&lang=ts"

import "./DailyReportExternalPreview.vue?vue&type=style&index=0&id=22c2ec7b&lang=scss"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QScrollArea,QSpinner});
